import Dexie from 'dexie'
import { type EntityTable } from 'dexie'
import type { CustomSearchDefinition } from '~/domain/csearch'
import { defineStore } from 'pinia'
if (import.meta.client) {
  await import('dexie-observable')
}
export interface CsEntry {
  id: string
  sort: number
  schemaVersion: number
  cs: CustomSearchDefinition
}

type EventType = 'CREATED' | 'UPDATED' | 'DELETED'
export type CsStoreListener = (key: string, type: EventType) => void

const types: EventType[] = ['CREATED', 'UPDATED', 'DELETED']
const csSchemaVersion = 1


export const useCsStore = defineStore(
  'csstore',
  () => {
    let css: EntityTable<CsEntry, 'id'> | null = null
    const listeners: CsStoreListener[] = []

    const addListener = (l: CsStoreListener) => {
      listeners.push(l)
    }

    const removeListener = (l: CsStoreListener) => {
      removeFromArray(listeners, l)
    }

    if (import.meta.client) {
      const db = new Dexie('jps-cs-database') as Dexie & {
        css: EntityTable<CsEntry, 'id'>
      }
      db.version(csSchemaVersion).stores({
        css: '&id,sort',
      })
      db.on('populate', async (tx) => {
        const id = await addCs(
          {
            name: { ja: '最初のカスタム検索', en: 'First custom search' },
            keywordFields: ['keywords'],
          },
          0
        )
      })
      db.on('changes', async (changes) => {
        changes.forEach((change) => {
          listeners.forEach((l) => {
            l(change.key, types[change.type - 1])
          })
        })
      })
      css = db.table('css')
    }

    const getAll = async (): Promise<CsEntry[]> => {
      return await css.orderBy('sort').toArray()
    }

    const sort = async (ids: string[]) => {
      ids.forEach((id, index) => {
        css!.update(id, { sort: index })
      })
    };

    const updateCs = async (cs: CustomSearchDefinition) => {
      await css.update(cs.id, {
        cs,
      } as CsEntry)
      return await css.get(cs.id)
    }

    const addCs = async (cs: CustomSearchDefinition, sort: number): Promise<string> => {
      cs.id = 'jpsmys-' + luId()
      await css.add({
        id: cs.id,
        sort,
        cs,
        schemaVersion: csSchemaVersion,
      } as CsEntry)
      return cs.id
    }

    const deleteCs = async (id: string) => {
      await css.delete(id)
    }

    const getCs = async (id: string) => {
      return await css.get(id)
    }

    return {
      addListener,
      removeListener,
      getAll,
      sort,
      updateCs,
      addCs,
      deleteCs,
      getCs,
    }
  }
)